export class GearingMode {
  static MaxTorque:number = 0;
  static Geometric: number = 1;
}
